import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO'
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic'
import {PAdbContext} from '../PA.Core/PAdbContext'
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_CircularConfigCRRow,
    WB_CircularConfigRow,
    WB_CompanyRow,
    WB_DataObjectColumnRow,
    WB_MasterDataSetRow,
    WB_SalesOrgRow,
} from "../PA.Core/PAdbSchemaRows";
import {IwbCircularConfig} from "../PA.Core/PAdbSchemaRowsIF"
import {
    esWB_Circular_Config,
    esWB_Circular_ConfigCR,
    esWB_Company,
    esWB_DataObject_Column,
    esWB_MasterData_Set,
    esWB_SalesOrg,
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord"
import {ESDataStore} from "../PA.Core/lib/ESDataStore"
import {PAEnvironment} from "../PA.Core/PAEnvironment"
import {CircularConfigBOValidations} from "./CircularConfigBO.Validations"
import { CreateOptions, ESRecordResolver } from '../PA.Core/lib/ESRecordResolver'
import { ASync } from '../PA.Core/Basic/ASync'
import { IJobParam } from "../PA.Job.Core/PA.Job.IF.JobParam";
import { JobParamManager } from "../PA.Job.Core/JobParamManager";


export class CircularConfigBO implements IBusinessObject
{
    Identity: IdentityProvider

    CreateOptions: any

    LoadOptions: any
    _bIsLoaded: boolean
    _OnLoadComplete: Promise<IBusinessObject>
    LoadProgressProvider: IProgressProvider

    ValidateOptions: any
    _bIsValidated: boolean
    ValidateMessageProvider: IMessageProvider
    ValidateProgressProvider: IProgressProvider

    SaveOptions: any
    _bIsSaved: boolean
    SaveProgressProvider: IProgressProvider

    DeleteOptions: any
    _bIsDeleted: boolean
    DeleteMessageProvider: IMessageProvider
    DeleteProgressProvider: IProgressProvider

    dbContext: PAdbContext
    private drWB_CircularConfig: WB_CircularConfigRow

    constructor(options?: any) {

        this.CreateOptions = options || {}

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext

        this.Identity = new IdentityProvider({id: 0, name: 'New Circular Config'})

        this.LoadOptions = {}
        this._bIsLoaded = false
        this._OnLoadComplete = null
        this.LoadProgressProvider = new ProgressProvider('Loading', this)

        this.ValidateOptions = {}
        this._bIsValidated = false
        this.ValidateMessageProvider = new MessageProvider()
        this.ValidateProgressProvider = new ProgressProvider("Validating", this)

        this.SaveOptions = {}
        this._bIsSaved = false
        this.SaveProgressProvider = new ProgressProvider("Saving", this)

        this.DeleteOptions = {}
        this._bIsDeleted = false
        this.DeleteMessageProvider = new MessageProvider()
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this)

        this.drWB_CircularConfig = null
    }

    get WB_CircularConfig(): WB_CircularConfigRow {
        return this.drWB_CircularConfig
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        let self = this
        this.LoadProgressProvider.start("Creating Circular Config")
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {}
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext
            else
                self.dbContext = new PAdbContext()

            if (_.isEmpty(self.dbContext)) {
                let sError = "Unable to determine dbContext for new Circular Config."
                self._OnLoadComplete = null
                self.LoadProgressProvider.exception(sError)
                error(sError)
                return
            }

            // Create record using dbContext
            self.dbContext.createRecordWithKey(esWB_Circular_Config)
                .then((newCircularConfigRow: WB_CircularConfigRow) => {
                    newCircularConfigRow.setDefaults()
                    self.drWB_CircularConfig = newCircularConfigRow
                    self.drWB_CircularConfig.cif.WB_MDSET_ID = self.LoadOptions.wbMasterDataSetId || 0
                    self.drWB_CircularConfig.cif.WB_SALESORG_ID = self.LoadOptions.wbSalesOrgId || 0
                    self.drWB_CircularConfig.cif.CONFIG_ID = self.LoadOptions.sId
                    self.drWB_CircularConfig.cif.CONFIG_NAME = self.LoadOptions.sName

                    return self.dbContext.find(esWB_MasterData_Set, self.drWB_CircularConfig.cif.WB_MDSET_ID)
                })
                .then((rowMDSet: WB_MasterDataSetRow)=>{
                    self.drWB_CircularConfig.WB_MDSetRow= rowMDSet
                    return self.dbContext.find(esWB_SalesOrg, self.drWB_CircularConfig.cif.WB_SALESORG_ID)
                })
                .then((rowSalesOrg: WB_SalesOrgRow) => {
                    self.drWB_CircularConfig.WB_SalesOrgRow= rowSalesOrg
                    return self.dbContext.find(esWB_Company, rowSalesOrg.cif.WB_COMPANY_ID)
                })
                .then((rowCompany: WB_CompanyRow) => {
                    self.drWB_CircularConfig.WB_SalesOrgRow.WB_CompanyRow = rowCompany
                    return self.IJobParam_OnLoadComplete()
                })
                .then(() => {
                    self.dbContext.add(esWB_Circular_Config, self.drWB_CircularConfig)
                    self.Identity.setAll(self.WB_CircularConfig.cif.WB_CIRCULARCONFIG_ID, self.WB_CircularConfig.cif.CONFIG_ID, self.WB_CircularConfig.cif.CONFIG_NAME)
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")")

                    self.LoadProgressProvider.finish()
                    self._bIsLoaded = true
                    self._OnLoadComplete = null
                    resolve(self)
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        })

        return this._OnLoadComplete
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this
        if (!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading Circular Config (' + anId + ')')
        
        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        let returnValue = self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")")

            if (self.bIsLoaded) {
                const sError = "Circular Config already loaded."
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(sError)
                error(sError)
                return
            }

            self.LoadOptions = options || {}
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext
            else
                self.dbContext = new PAdbContext()

            if (_.isEmpty(self.dbContext)) {
                let sError = "Unable to determine dbContext for new Circular Config."
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(sError)
                error(sError)
                return
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = CircularConfigBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = CircularConfigBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function () {
                    let aCircularConfigRow: any = recordResolver.get(esWB_Circular_Config, anId)

                    if (_.isEmpty(aCircularConfigRow)) {
                        error("CircularConfig not Found");
                        return;
                    }

                    self.drWB_CircularConfig = aCircularConfigRow;
                    self.Identity.setAll(self.WB_CircularConfig.cif.WB_CIRCULARCONFIG_ID, self.WB_CircularConfig.cif.CONFIG_ID, self.WB_CircularConfig.cif.CONFIG_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_CircularConfig, 'WB_CIRCULARCONFIG_ID', 'CONFIG_ID', 'CONFIG_NAME')

                    return self.IJobParam_OnLoadComplete()
                })
                .then(() => {
                    self._bIsLoaded = true
                    self._OnLoadComplete = undefined
                    self.LoadProgressProvider.finish()
                    resolve(self)
                })
                .catch(function (err: any) {
                    self._OnLoadComplete = undefined
                    self.LoadProgressProvider.exception(err)
                    error(err)
                    return;
                });
        })

        return returnValue
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded
    }

    async Validate(options?: any): Promise<IBusinessObject> {

        const self = this

        try {
            self.ValidateMessageProvider.clearMessages()
            self.ValidateProgressProvider.start("Validating " + self.WB_CircularConfig.cif.CONFIG_NAME + "(" + self.WB_CircularConfig.cif.CONFIG_ID + ")")


            self.ValidateOptions = options || {}

            if (self.dbContext == undefined) {
                var sError = "Unable to determine dbContext for to Validate Circular Config."
                self.ValidateProgressProvider.exception(sError)
                throw new Error(sError)
            }

            await CircularConfigBOValidations.ValidateEmptyFields(self)

            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self._bIsValidated = false
            } else {
                self._bIsValidated = true
            }
            self.ValidateProgressProvider.finish()
            return self

        } catch (err) {
            self._bIsValidated = false
            self.ValidateProgressProvider.exception(err)
            return self
        }
    }

    get bIsValidated(): boolean {
        return this._bIsValidated
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this
        const wbCircularConfig = <IwbCircularConfig>self.drWB_CircularConfig
        self.SaveProgressProvider.start("Saving " + wbCircularConfig.CONFIG_NAME + "(" + wbCircularConfig.CONFIG_ID + ")")

        // Doesn't need to do anything yet
        // All the records are in the store, since they were added through find or createNewRecord.
        // -- We could search the tree if the there is any record where store isn't set.
        try {
            if (self.dbContext == undefined) {
                self._bIsSaved = false
                var sError = "Unable to determine dbContext to Save Circular Config."
                self.SaveProgressProvider.exception(sError)
                throw new Error(sError)
                return
            }

            self.SaveOptions = options || {}

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            // Add code to do individual BO save for dbContextRows....
            await self.Validate({})

            if (!self.bIsValidated) {
                self._bIsSaved = false
                self.SaveProgressProvider.finish()
                return self
            }

            await saveFunction(esWB_Circular_Config, self.drWB_CircularConfig, {})
            await saveFunction(esWB_Circular_ConfigCR, self.drWB_CircularConfig.WB_CircularConfigCRRows, {})

            if (!self.JobParam) {
                if (self.WB_CircularConfig.isActive) {
                    await self.IJobParam_OnLoadComplete();
                }
            }
            if (self.JobParam) {
                self.JobParam.id_ui = wbCircularConfig.CONFIG_ID;
                self.JobParam.name = wbCircularConfig.CONFIG_NAME;
                await self.JobParam.Save(bBatch);
            }

            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true
                })
            } else {
                self._bIsSaved = true
            }

            self.SaveProgressProvider.finish()
            return self
        } catch (err) {
            self.SaveProgressProvider.exception(err)
            return self
        }

    }

    get bIsSaved(): boolean {
        return this._bIsSaved
    }

    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbCircularConfig = <IwbCircularConfig>self.drWB_CircularConfig;
        this.DeleteMessageProvider.clearMessages()
        this.DeleteProgressProvider.start("Deleting " + wbCircularConfig.CONFIG_NAME + "(" + wbCircularConfig.WB_CIRCULARCONFIG_ID + ")")
        try {
            // 1. Validate if we can delete the CircularConfig

            // 2. If Valid, mark all the records for deletion.
            self.drWB_CircularConfig.markDeleted();

            _.forEach(self.drWB_CircularConfig.WB_CircularConfigCRRows, (row) => {
                if (row.isActive)
                    row.markDeleted();
            });

            if (self.JobParam) {
                await self.JobParam.Delete(bSaveNow);
            }

            if (bSaveNow) {
                await self.SaveUsing(false);
            }

            self._bIsDeleted = true;
            self.DeleteProgressProvider.finish();
        } catch (err) {
            this.DeleteProgressProvider.exception(err);
        }
        return self;
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted
    }

    //</editor-fold>

    //<editor-fold desc = "Add Remove operations">

    async addCircularConfigCR(aDataObjectColumnRowId: number): Promise<WB_CircularConfigCRRow> {
        const self = this
        let aColumnRow: WB_DataObjectColumnRow = <WB_DataObjectColumnRow>await self.dbContext.find(esWB_DataObject_Column, aDataObjectColumnRowId)

        if (_.isEmpty(aColumnRow))
            return

        let aNewRecord: WB_CircularConfigCRRow = <WB_CircularConfigCRRow>await self.dbContext.createRecordWithKey(esWB_Circular_ConfigCR)
        aNewRecord.setDefaults()
        aNewRecord.WB_CircularConfigRow = self.drWB_CircularConfig
        aNewRecord.cif.WB_CIRCULARCONFIG_ID = self.drWB_CircularConfig.cif.WB_CIRCULARCONFIG_ID
        aNewRecord.WB_DataObjectColumnRow = aColumnRow
        aNewRecord.cif.WB_DATAOBJECT_COLUMN_ID = aColumnRow.cif.WB_DATAOBJECT_COLUMN_ID
        self.dbContext.add(esWB_Circular_ConfigCR, aNewRecord)
        console.log("Debug add: ", self.drWB_CircularConfig.WB_CircularConfigCRRows)
        return aNewRecord
    }

    async removeCircularConfigCR(aDataObjectColumnRowId: number): Promise<void> {
        const self = this
        _.forEach(self.drWB_CircularConfig.WB_CircularConfigCRRows, (a) => {
            if (!a.isActive) return
            if (a.cif.WB_DATAOBJECT_COLUMN_ID == aDataObjectColumnRowId)
                a.markDeleted()
        })

        console.log("Debug remove: ", self.drWB_CircularConfig.WB_CircularConfigCRRows)

    }

    //</editor-fold>

    //<editor-fold desc = "Job Param">

    _jobParam: IJobParam;

    async IJobParam_OnLoadComplete(): Promise<void> {
        if (!_.isEmpty(this._jobParam)) {
            return;
        }
        const jpMgr = new JobParamManager();
        const wbCircularConfig: IwbCircularConfig = this.WB_CircularConfig.cif;

        this._jobParam = await jpMgr.findOrCreate({
            dbContext: this.dbContext,
            JobSchedulerModuleId: "",

            sourceType: "CircularConfig",
            sourceWbId: wbCircularConfig.WB_CIRCULARCONFIG_ID,

            appExecId: "CircularConfig",
            wbTargetId: wbCircularConfig.WB_CIRCULARCONFIG_ID,

            wbMasterDataSetId: wbCircularConfig.WB_MDSET_ID,
            wbCompanyId: this.WB_CircularConfig.WB_SalesOrgRow.WB_CompanyRow?.cif.WB_COMPANY_ID,
            wbSalesOrgId: wbCircularConfig.WB_SALESORG_ID,

            JobParamId: wbCircularConfig.CONFIG_ID,
            JobParamName: wbCircularConfig.CONFIG_NAME,
            JobProcessorType: "CircularAssignmentProcessor",
            DependentTriggerId: "CircularAssignment",
        });
    }

    get JobParam(): IJobParam {
        return this._jobParam;
    }

    //</editor-fold>

    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const cc_options: CreateOptions = {
            standardConditions: {
            },
            dctIncludeBelongsToNamedRelations: {
            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, cc_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Circular_Config, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }
    //</editor-fold>

}
PAEnvironment.registerBusinessObjectClass(CircularConfigBO , "CircularConfigBO", "Circular Config")
